<template>
  <div class="not-found">
    <a-result status="404" title="404" sub-title="页面不存在，请检查路径是否正确">
      <template #extra>
          <ButtonField text="返回上一页" primary @click="back"/>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.not-found {
  padding-top: 120px;
}
::v-deep .ant-result-title{
  color: #00ff96;
}
::v-deep  .ant-result-subtitle{
  color: rgba(255 255 255 / 45%);
}
</style>